import React, { useMemo } from "react";
import { connect } from "react-redux";
import { mapStateToPropsLogin } from "../../../modules/login";
import styled, { withTheme } from "styled-components";
import ProfileCard from "../../../components/ui-library/ProfileCard/ProfileCard";
import SmartPageHeader from "../../../components/smart/PageHeader/PageHeader";
import SmartParticipantTable from "../../../components/smart/ParticipantTable/ParticipantTable";
import SmartNonParticipantTable from "../../../components/smart/NonParticipantTable/NonParticipantTable";

const ProfileCardsWrapper = styled.div``;

const Landing = (props) => {
  const { claims, route, sites, studies } = props;
  const siteId = useMemo(
    () =>
      sites && sites.length > 0 && sites.length < 2 ? sites[0].siteId : null,
    [sites]
  );

  const studyCode = useMemo(
    () =>
      studies?.find(
        (o) => o?.studyId?.toLowerCase() === route?.study?.toLowerCase()
      )?.code ?? "",
    [studies, route]
  );

  return (
    <>
      <SmartPageHeader studyId={route.study} title={studyCode} />

      <ProfileCardsWrapper>
        <ProfileCard title={`${studyCode} participants`} showIcon={false}>
          <SmartParticipantTable studyId={route.study} {...{ siteId }} />
        </ProfileCard>

        {claims?.includes("nonParticipant.canView") && (
          <div className="mt-4">
            <ProfileCard
              title={`${studyCode} Non-Participants`}
              showIcon={false}
            >
              <SmartNonParticipantTable
                studyId={route.study}
                studyCode={studyCode}
              />
            </ProfileCard>
          </div>
        )}
      </ProfileCardsWrapper>
    </>
  );
};

export default connect(mapStateToPropsLogin, null)(withTheme(Landing));
